import { useTranslation } from 'next-i18next/pages';
import React from 'react';

import EmojiText from '../emoji-text/EmojiText';

interface BasicSalaryDetailsProps {
  oneYearExperience?: number;
  threeYearExperience?: number;
  eightYearExperience?: number;
}

export const BasicSalaryDetails: React.FC<BasicSalaryDetailsProps> = ({
  oneYearExperience = 0,
  threeYearExperience = 0,
  eightYearExperience = 0,
}) => {
  const { t } = useTranslation('jobDetails', { keyPrefix: 'salaryDetails' });
  return (
    <div className='my-4 md:my-6'>
      <EmojiText className='text-main-blue text-lg font-medium' emoji='💶'>
        {t('basicSalary')}
      </EmojiText>
      {oneYearExperience > 0 && (
        <div className='mt-4 flex'>
          <p className='text-default text-sm font-normal'>{t('oneYearExperience')}</p>
          <p className='text-default ml-auto text-sm'>{oneYearExperience.toLocaleString('de')}€</p>
        </div>
      )}
      {threeYearExperience > 0 && (
        <div className='mt-2 flex md:mt-4'>
          <p className='text-default text-sm font-normal'>{t('threeYearExperience')}</p>
          <p className='text-default ml-auto text-sm'>{threeYearExperience.toLocaleString('de')}€</p>
        </div>
      )}
      {eightYearExperience > 0 && (
        <div className='mt-2 flex md:mt-4'>
          <p className='text-default text-sm font-normal'>{t('eightYearExperience')}</p>
          <p className='text-default ml-auto text-sm'>{eightYearExperience.toLocaleString('de')}€</p>
        </div>
      )}
    </div>
  );
};

export default BasicSalaryDetails;
